export const PROCEDURE_STATUS = {
  NOT_SCHEDULED: 'not_scheduled',
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in_progress',
} as const;

export type ProcedureStatus = (typeof PROCEDURE_STATUS)[keyof typeof PROCEDURE_STATUS];

export const PLANNING_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
} as const;

export type PlanningStatus = (typeof PLANNING_STATUS)[keyof typeof PLANNING_STATUS];

export const CONNECTION_STATUS = {
  NOT_CONNECTED: 'not_connected',
  CONNECTED: 'connected',
  SYNCING: 'syncing',
  COMPLETED: 'completed',
} as const;
export type ConnectionStatus = (typeof CONNECTION_STATUS)[keyof typeof CONNECTION_STATUS];

export const PHASE_STEP_STATUS = {
  WAITING: 'waiting',
  IN_PROGRESS: 'in_progress',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  COMPLETED: 'completed',
} as const;

export type PhaseStepStatus = (typeof PHASE_STEP_STATUS)[keyof typeof PHASE_STEP_STATUS];
